import clsx from 'clsx';
import React from 'react';

import { highlight_path } from '@routes';

import styles from './styles.module.scss';

export default function Highlight({ name, slug }: { name: string; slug: string }) {
  return (
    <a
      href={highlight_path(slug)}
      className={clsx('track-link', styles.highlight)}
      data-type="link"
      data-name="article highlight"
      data-location="feed"
    >
      {name}
    </a>
  );
}
